import {
  ProjectMemberRole,
  ProjectSortOption,
  useListProjectsBasicInfoQuery,
} from '@graphql/generated';

import {
  DEFAULT_PER_PAGE_COUNT,
  ListProjectsSharedQueryResult,
  useListProjectsBasicInfoShared,
} from './useListProjectsBasicInfoShared';

interface ListProjectsBasicInfoFromQueryProps {
  userId?: string;
  sortBy?: ProjectSortOption;
  role?: ProjectMemberRole;
  archivesOnly?: boolean;
  locationOnly?: boolean;
  onCompleted?: () => void;
  onError?: () => void;
  first?: number;
  last?: number;
  after?: string;
  before?: string;
  filterTeamsProjects?: boolean;
}

export const useListProjectsBasicInfoFromQuery = (
  props?: ListProjectsBasicInfoFromQueryProps
) => {
  const {
    userId = undefined,
    sortBy = undefined,
    role = undefined,
    filterTeamsProjects = false,
    archivesOnly = false,
    locationOnly = false,
    onCompleted = undefined,
    onError = undefined,
    first = DEFAULT_PER_PAGE_COUNT,
    last = undefined,
    after = undefined,
    before = undefined,
  } = props || {};

  const queryResult = useListProjectsBasicInfoQuery({
    variables: {
      userId,
      sortBy,
      role,
      archivesOnly,
      locationOnly,
      first,
      last,
      filterTeamsProjects,
      before,
      after,
    },
    fetchPolicy: 'cache-and-network',
  });

  return useListProjectsBasicInfoShared(
    queryResult as unknown as ListProjectsSharedQueryResult,
    { archivesOnly, first, onCompleted, onError }
  );
};
